import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.afterservice.statistics');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-afterservice-statistics',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.afterservice.statistics/view.scss */
/* src/app/portal.afterservice.statistics/view.scss: no such file or directory */`],
})
export class PortalAfterserviceStatisticsComponent implements OnInit {
    @Input() title: any;

    public count1: number = 0;
    public count2: number = 0;

    constructor(@Inject( Service) public service: Service) {}

    public async ngOnInit() {
        await this.service.init();
        await this.load();
        await this.service.render();
    }

    private async load() {
        const res = await wiz.call('count');
        if (res.code === 200) {
            this.count1 = res.data.count1 || 0;
            this.count2 = res.data.count2 || 0;
        }
    }
}

export default PortalAfterserviceStatisticsComponent;